// extracted by mini-css-extract-plugin
module.exports = {"details":"ProductionStageDetails_details__3K9LR"};